export default {
  //метод записывающий данные по пользователям с учетом поиска и первоначальной загрузки
  SET__AllData (state, dataInServer) {
    state.data = dataInServer
  },
  SET__AddNewData (state, dataInServer) {
    dataInServer['candidates'].length > 0 ? state.data['candidates'] = state.data['candidates'].concat(dataInServer['candidates']) : ''
  },
  //метод добавления , удаления пользователя в ВЫБРАННЫХ
  SET__selectedUser (state, user) {
    if(user.flag) {
      state.dataUsers.push(user.user)
    }
    else if(!user.flag) {
      state.dataUsers.forEach((el,i)=> {
        if(el.id === user.user.id) state.dataUsers.splice(i, 1)
      })
    }
  },
  // метод очистки всех выбранных пользователей
  SET__ClearSelectedUser (state) {
    state.dataUsers = []
  },
  // метод изменения страницы ( след. )
  SET__activePage (state) {
    state.page++
  },
  // метод перехода на первую страницу
  SET__activePageNullified (state) {
    state.page = 1
  },
  // Метод записи поисковой строки и переключение на 1 страницу т.ку. поиск
  SET__searchText ( state, stringSearch) {
    state.searchText = stringSearch;
    state.page = 1;
  },
  SET__searchProfile ( state, stringSearch) {
    state.searchProfile = stringSearch;
    state.page = 1;
  },
  SET__searchDates ( state, stringSearch) {
    state.searchDates = stringSearch;
    state.page = 1;
  },
  SET__searchStatus ( state, stringSearch) {
    state.searchStatus = stringSearch;
    state.page = 1;
  },
  // метод обнуления строки
  SET__searchNullified ( state) {
    state.search = ''
  },
  SET__loading(state, value) {
    state.loading = value;
  },
  SET__reset(state) {
    state.data = {};
    state.dataUsers = [];
    state.page = 1;
    state.searchText = '';
    state.searchProfile = '';
    state.searchDates = '';
    state.loading = false;
  }

}




